import {
  getCompanyId,
  getDepartmentName,
  getStoreId
} from 'components/StoreSelect/slice';
import { useFetchPrintChecksCIBAccounts } from 'hooks/useClientDataServices';
import { useAppSelector } from 'store/hooks';
import type { PrintChecksCIBDropdownResult } from './types';

export const usePrintChecksCIBData = (): PrintChecksCIBDropdownResult => {
  const companyId = useAppSelector(getCompanyId);
  const storeId = useAppSelector(getStoreId);
  const selectedDepartmentName = useAppSelector(getDepartmentName);

  const queryResult = useFetchPrintChecksCIBAccounts(
    companyId,
    storeId,
    selectedDepartmentName ?? ''
  );
  const queryData = queryResult?.data || [];
  return { queryData, ...queryResult };
};
